import { render, staticRenderFns } from "./PopupHowToWrite.vue?vue&type=template&id=b0e6adb2&scoped=true"
import script from "./PopupHowToWrite.vue?vue&type=script&lang=js"
export * from "./PopupHowToWrite.vue?vue&type=script&lang=js"
import style0 from "./PopupHowToWrite.vue?vue&type=style&index=0&id=b0e6adb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e6adb2",
  null
  
)

export default component.exports